import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import Store from './store';

Vue.use(Router);

var adminRouter = [{
  path: '/',
  name: 'home',
  component: Home,
},
{
  path: '/users',
  name: 'users',
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  component: () => import(/* webpackChunkName: "users" */ './views/Users.vue'),
},
{
  path: '/deliveryAddresses',
  name: 'deliveryAddresses',
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  component: () => import(/* webpackChunkName: "addresses" */ './views/Addresses.vue'),
},
{
  path: '/settings',
  name: 'settings',
  component: () => import(/* webpackChunkName: "settings" */ './views/Settings.vue'),
}
];

var clientRouter = [{
  path: '/',
  name: 'home',
  component: Home,
},];

var used_routes = clientRouter;
let currentUser = Store.getters['user/currentUser'];
if(currentUser !== undefined && currentUser.userRoleId == 1) {
  console.log("is administrator !");
  used_routes = adminRouter
}
let router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    {
      path: '/users',
      name: 'users',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "users" */ './views/Users.vue'),
      meta: { 
        is_admin : true
      }
    },
    {
      path: '/freightforwarders',
      name: 'freightforwarders',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "users" */ './views/FreightForwarders.vue')
    },
    {
      path: '/addresses',
      name: 'addresses',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "users" */ './views/Addresses.vue'),
      meta: { 
        is_admin : true
      }
    },
    {
      path: '/deliveryAddresses',
      name: 'deliveryAddresses',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "addresses" */ './views/DeliveryAddresses.vue')
    },
    {
      path: '/drivers',
      name: 'drivers',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "drivers" */ './views/Drivers.vue'),
    },
    {
      path: '/NotificationsDetailed',
      name: 'NotificationsDetailed',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "drivers" */ './views/NotificationsDetailed.vue')
    },
    {
      path: '/phones',
      name: 'phones',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "phones" */ './views/MobilePhones.vue'),
      meta: { 
        is_admin : true
      }
    },
    {
      path: '/trucks',
      name: 'trucks',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "trucks" */ './views/Trucks.vue'),
    },
    {
      path: '/settings',
      name: 'settings',
      component: () => import(/* webpackChunkName: "settings" */ './views/Settings.vue'),
      meta: { 
        is_admin : true
      }
    },
    {
      path: '/contactTickets',
      name: 'contactTickets',
      component: () => import(/* webpackChunkName: "contactTickets" */ './views/ContactTickets.vue'),
      meta: { 
        is_admin : true
      }
    },
    {
      path: '/languages',
      name: 'languages',
      component: () => import(/* webpackChunkName: "languages" */ './views/Languages.vue')
    },
    {
      path: '/waybills',
      name: 'waybills',
      component: () => import(/* webpackChunkName: "languages" */ './views/Waybills.vue'),
    },
    {
      path: '/privacy-policy',
      name: 'privacy-policy',
      component: () => import(/* webpackChunkName: "languages" */ './views/PrivacyPolicy.vue'),
      meta: { 
        is_admin : true
      }
    },
  ]
});

router.beforeEach((to, from, next) => {
  var roleId = localStorage.getItem("UserRoleId");  
  if(to.matched.some(record => record.meta.is_admin)) {
      if(roleId == 1){
          next()
      }
      else{
          next({ name: 'home'})
      }
  }else{
    next()
  }
})


export default router;